<template>
  <div
    :class="headerClass"
    class="sam-section-header"
    data-testid="sam-section-header"
  >
    <div
      v-if="hasBreadcrumbsSlot"
      class="mb-4"
    >
      <slot name="breadcrumbs" />
    </div>

    <div class="d-flex items-center">
      <div class="w-100">
        <div class="sam-section-header__container__title">
          <SamIcon
            v-if="icon.length"
            :icon="icon"
          />
          <h5
            class="text--ellipse"
            data-testid="sam-section-header__title"
            :bablic-exclude="dontTranslateTitle"
            v-text="title"
          />
          <slot name="title-append" />
        </div>
        <h6
          v-if="subtitle.length"
          class="text--body-2 mt-2"
          data-testid="sam-section-header__subtitle"
          :bablic-exclude="dontTranslateSubTitle"
          v-html="subtitle"
        />
        <h6
          v-else-if="hasSubtitleSlot"
          data-testid="sam-section-header__subtitle-slot"
          class="text--body-2 d-flex flex-baseline mt-2"
        >
          <slot name="subtitle" />
        </h6>
      </div>

      <div
        class="ml-auto d-flex end-xs items-center"
        data-testid="sam-section-header__actions"
      >
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
import SamIcon from '../SamIcon/SamIcon.vue';

export default {
  name: 'SamSectionHeader',
  components: {
    SamIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
      required: false,
    },
    icon: {
      type: String,
      default: '',
      required: false,
    },
    headerClass: {
      type: String,
      default: 'mb-6',
      required: false,
    },
    /**
     * If the title should be excluded from translation
     */
    dontTranslateTitle: {
      type: Boolean,
      default: false,
      required: false,
    },
    /**
     * If the subtitle should be excluded from translation
     */
    dontTranslateSubTitle: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    hasBreadcrumbsSlot() {
      return !!this.$slots.breadcrumbs;
    },
    hasSubtitleSlot() {
      return !!this.$slots.subtitle;
    },
  },
};
</script>

<style lang="scss" scoped>
.sam-section-header__container__title {
  @extend .d-flex, .flex-center;
  column-gap: $size--2;
}
</style>
